module.exports = __webpack_public_path__ + "media/packs/images/missing-6beb5a5cc564193726f0282354793719.png";